import * as React from 'react';
import { useTheme } from '@mui/material';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useTranslation } from 'react-i18next';

interface UserSettingsProps {
  handleOpenDialog: (event: React.MouseEvent<HTMLElement>) => void;
}

export default function UserSettings(props: Readonly<UserSettingsProps>) {
  const { handleOpenDialog } = props;
  const theme = useTheme();
  const { t } = useTranslation('account');

  return (
    <ListItem disablePadding>
      <ListItemButton onClick={handleOpenDialog} data-id="user-settings">
        <ListItemIcon>
          <theme.icons.manageAccount fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={t('menu.user settings')} />
      </ListItemButton>
    </ListItem>
  );
}
